const checkIfLoaded = (func, loaded, params) => {
  if (loaded === true) {
    func(params);
  }
};

export default checkIfLoaded;
